export default __webpack_public_path__ + "static/media/mint-incentive-track.d4a59da7.png";